export default function arraysHasMatchingValue<T>(a: T[], b: T[]): boolean {
	return a.some(v => b.includes(v));
}
